import {Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {NgModel} from "@angular/forms";

@Component({
    selector: 'radio-container',
    templateUrl: './radio-container.component.html',
    providers: []
})
export class RadioContainerComponent implements OnInit, AfterViewInit{

    @Input() id;
    @Input() value;
    @Input() name;
    @Input() label;
    @Input() disabled;

    @ViewChild("wcradio", {read: ElementRef}) child: ElementRef;
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    modelValue = "";
    @Output() modelChange:EventEmitter<any> = new EventEmitter<any>();
    isChecked:boolean=false;

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.modelValue = val;
        this.modelChange.next(this.modelValue);
        // this.isChecked = !val?false:true;
    }

    ngAfterViewInit(): void {
        this.child.nativeElement.addEventListener("change",(event) => {
            this.modelValue = event.detail;
            this.modelChange.next(this.modelValue);
            if(!!this.onChange){
                this.onChange.emit();
            }
        });
    }

    ngOnInit(): void {
        this.isChecked = this.model===this.value;
        this.disabled= !!this.disabled?this.disabled:false;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/radio-container/radio-container.component.ts